import * as React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Catalog } from '../pages/catalog';
import { Support } from '../pages/support';
import { DetailPage } from '../pages/detailPage';
import { FaqsPage } from '../pages/faqs';
import { Home } from '../pages/home';
import { OurStores } from '../pages/ourStores';
import { TermsConditions } from './temsConditions/TermsConditions';
import { TuxBox } from '../pages/tuxBox';
import { EventDatePicker } from './rentForm/EventDatePicker';
import { TheLook } from './rentForm/TheLook';

export function Main() {
  return (
    <Routes>
      <Route index path="/" element={<Home />} />
      <Route path="/catalog" element={<Catalog />} />
      <Route path="/tuxedos-box" element={<TuxBox />} />
      <Route path="/details/:productId" element={<DetailPage />} />
      <Route path="/faqs" element={<FaqsPage />} />
      <Route path="/support" element={<Support />} />
      <Route path="/our-stores" element={<OurStores />} />
      <Route path="/terms-conditions" element={<TermsConditions />} />

      <Route path="/event-date-picker" element={<EventDatePicker />} />
      <Route path="/the-look" element={<TheLook />} />

      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}
